import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetAISummaryByRecordingUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (record: string, channel: string): Promise<any> => {
        return await this._aiRepository.getAISumaryByRecord(record, channel);
    }
}

export const GetAISummaryByRecordingUseCaseName = "GetAISummaryByRecordingUseCaseName";